import { Fragment } from 'react';
import { strings } from '../strings';

/** Keys of a shortcut as `.kbd` chips: "Ctrl + K", or "G then B" for a sequence. */
export function Keys({ keys, sequence }: { keys: readonly string[]; sequence?: boolean }) {
  return (
    <span className="inline-flex items-center gap-1 whitespace-nowrap">
      {keys.map((key, i) => (
        <Fragment key={i}>
          {i > 0 && (
            <span className="text-[11px] text-fg-muted">{sequence ? strings.shell.shortcuts.then : '+'}</span>
          )}
          <kbd className="kbd">{key}</kbd>
        </Fragment>
      ))}
    </span>
  );
}
